// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__1UFFj","tab":"style_tab__3eP0_","active":"style_active__1XtHh"};